var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5C19.1274 0.5 24.5 5.87258 24.5 12.5C24.5 19.1274 19.1274 24.5 12.5 24.5C5.87258 24.5 0.5 19.1274 0.5 12.5C0.500002 5.87258 5.87258 0.5 12.5 0.5Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88801 10.8701C10.4971 10.8701 10.9909 10.0639 10.9909 9.06935C10.9909 8.0748 10.4971 7.26855 9.88801 7.26855C9.27892 7.26855 8.78516 8.0748 8.78516 9.06935C8.78516 10.0639 9.27892 10.8701 9.88801 10.8701Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1107 10.8701C15.7198 10.8701 16.2135 10.0639 16.2135 9.06935C16.2135 8.0748 15.7198 7.26855 15.1107 7.26855C14.5016 7.26855 14.0078 8.0748 14.0078 9.06935C14.0078 10.0639 14.5016 10.8701 15.1107 10.8701Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54688 12.5059C4.54688 16.898 8.10754 20.4586 12.4996 20.4586C16.8918 20.4586 20.4524 16.898 20.4524 12.5059",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/Smiley.f6cf0c609a079b2a558f878b71262b16.svg";
export { ForwardRef as ReactComponent };